import React, {useState,useEffect} from 'react';
import {useNavigate,useParams} from 'react-router-dom';
import BusinessEditPage from '../BusinessEditPage';
import {resolveBusinessIdentifier} from '../utils/businessSlug';
import './BusinessEditRoute.css';
export default function BusinessEditRoute({ renderMainMenu, db, user, businessTypes, fetchAllBusinesses }) {
  const navigate = useNavigate();
  const params = useParams();
  const businessParam = params?.businessId || null;
  const [resolvedBusinessId, setResolvedBusinessId] = useState(null);
  const [resolving, setResolving] = useState(true);
  const [resolveError, setResolveError] = useState('');
  const [resolveAttempt, setResolveAttempt] = useState(0);

  useEffect(() => {
    let mounted = true;
    async function resolve() {
      if (!businessParam) {
        if (mounted) {
          setResolvedBusinessId(null);
          setResolveError('No se pudo identificar el negocio. Vuelve a la lista e intenta abrirlo nuevamente.');
          setResolving(false);
        }
        return;
      }

      setResolving(true);
      setResolveError('');
      try {
        const result = await resolveBusinessIdentifier(db, businessParam);
        if (!result.business || !result.businessId) throw new Error('business-unavailable');
        const realId = result.businessId;
        if (mounted) setResolvedBusinessId(realId);
      } catch (_) {
        if (mounted) {setResolvedBusinessId(null);setResolveError('No pudimos abrir este negocio. Comprueba tu sesión e intenta nuevamente. No se ha cambiado ningún dato.');}
      } finally {
        if (mounted) setResolving(false);
      }
    }
    resolve();
    return () => { mounted = false; };
  }, [db, businessParam, resolveAttempt, user?.uid]);

  return (
    <div>
      {renderMainMenu({ headerOnly: true })}
      {resolving ? <section className="business-route-status" role="status">Abriendo negocio…</section> : resolveError ? <section className="business-route-status" role="alert"><h1>No pudimos abrir el negocio</h1><p>{resolveError}</p><div><button type="button" onClick={()=>setResolveAttempt(n=>n+1)}>Reintentar</button><button type="button" onClick={()=>navigate(-1)}>Volver a la lista</button></div></section> : (
        <BusinessEditPage
          key={resolvedBusinessId}
          db={db}
          user={user}
          businessTypes={businessTypes}
          businessId={resolvedBusinessId}
          onBack={() => navigate(-1)}
          onSaved={fetchAllBusinesses}
        />
      )}
    </div>
  );
}
